import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import Footer from "../../components/Layout/Footer";
import Navbar from "../../components/Layout/Navbar";

export default function BlogList() {

  const [blogs, setBlogs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchBlogs = async () => {

      try {

        const res = await api.get("/blogs");
        setBlogs(res.data);
        setFiltered(res.data);

      } catch (err) {

        console.error(err);

      } finally {

        setLoading(false);

      }

    };

    fetchBlogs();

  }, []);

  useEffect(() => {

    const result = blogs.filter((blog) =>
      blog.title.toLowerCase().includes(search.toLowerCase())
    );

    setFiltered(result);

  }, [search, blogs]);

  if (loading) {
    return <div style={styles.loading}>Loading blogs...</div>;
  }

  const featured = filtered[0];
  const rest = filtered.slice(1);

  return (
    <>
    <Navbar />

    <div style={styles.page}>

      <div style={styles.container}>

        {/* HEADER */}

        <div style={styles.header}>
          <h1 style={styles.title}>Blog</h1>

          <p style={styles.subtitle}>
            Tutorials, marketing insights and growth strategies.
          </p>
        </div>

        {/* SEARCH */}

        <div style={styles.searchWrapper}>
          <input
            placeholder="Search articles..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.search}
          />
        </div>

        {/* FEATURED BLOG */}

        {featured && (

          <Link
            to={`/blog/article/${featured.slug}`}
            style={styles.featuredCard}
          >

            <img
              src={featured.coverImage}
              alt={featured.title}
              style={styles.featuredImage}
            />

            <div style={styles.featuredContent}>

              <span style={styles.featuredBadge}>
                Featured Article
              </span>

              <h2 style={styles.featuredTitle}>
                {featured.title}
              </h2>

              <p style={styles.featuredExcerpt}>
                {featured.excerpt}
              </p>

            </div>

          </Link>

        )}

        {/* BLOG GRID */}

        <div style={styles.grid}>

          {rest.map((blog) => {

            // const words = blog.content?.split(" ").length || 0;
            // const readTime = Math.ceil(words / 200);

            return (

              <Link
                key={blog._id}
                to={`/blog/article/${blog.slug}`}
                style={styles.card}
              >

                {blog.coverImage && (

                  <img
                    src={blog.coverImage}
                    alt={blog.title}
                    style={styles.image}
                  />

                )}

                <div style={styles.cardBody}>

                  {blog.category && (
                    <span style={styles.category}>
                      {blog.category.name}
                    </span>
                  )}

                  <h2 style={styles.blogTitle}>
                    {blog.title}
                  </h2>

                  <p style={styles.excerpt}>
                    {blog.excerpt}
                  </p>

                  <div style={styles.meta}>

                  <span>{blog.views} views</span>
                    
                    <span>•</span>

                    {/* <span>{readTime} min read</span>

                    <span>•</span> */}

                    <span>
                      {new Date(
                        blog.publishedAt || blog.createdAt
                      ).toLocaleDateString()}
                    </span>

                  </div>

                </div>

              </Link>

            );

          })}

        </div>

      </div>

    </div>
    <Footer />
    </>
  );

}

const styles = {

  page:{
    background:"#f8fafc",
    minHeight:"100vh",
    padding:"40px 20px"
  },

  container:{
    maxWidth:"1200px",
    margin:"0 auto"
  },

  header:{
    marginBottom:"30px"
  },

  title:{
    fontSize:"36px",
    fontWeight:"700",
    marginBottom:"5px"
  },

  subtitle:{
    color:"#6b7280",
    fontSize:"16px"
  },

  searchWrapper:{
    marginBottom:"30px"
  },

  search:{
    width:"100%",
    maxWidth:"400px",
    padding:"10px",
    borderRadius:"8px",
    border:"1px solid #e5e7eb"
  },

  /* FEATURED */

  featuredCard:{
    display:"block",
    marginBottom:"40px",
    borderRadius:"12px",
    overflow:"hidden",
    textDecoration:"none",
    border:"1px solid #e5e7eb",
    background:"#fff"
  },

  featuredImage:{
    width:"100%",
    height:"350px",
    objectFit:"cover"
  },

  featuredContent:{
    padding:"25px"
  },

  featuredBadge:{
    fontSize:"12px",
    background:"#2563eb",
    color:"#fff",
    padding:"4px 8px",
    borderRadius:"6px",
    display:"inline-block",
    marginBottom:"10px"
  },

  featuredTitle:{
    fontSize:"28px",
    color:"#111827",
    marginBottom:"10px"
  },

  featuredExcerpt:{
    fontSize:"16px",
    color:"#6b7280"
  },

  /* GRID */

  grid:{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",
    gap:"25px"
  },

  card:{
    background:"#fff",
    borderRadius:"12px",
    overflow:"hidden",
    border:"1px solid #e5e7eb",
    textDecoration:"none",
    display:"block"
  },

  image:{
    width:"100%",
    height:"200px",
    objectFit:"cover"
  },

  cardBody:{
    padding:"20px"
  },

  category:{
    fontSize:"12px",
    background:"#eef2ff",
    color:"#4338ca",
    padding:"4px 8px",
    borderRadius:"6px",
    display:"inline-block",
    marginBottom:"8px"
  },

  blogTitle:{
    fontSize:"20px",
    color:"#111827",
    marginBottom:"8px"
  },

  excerpt:{
    fontSize:"15px",
    color:"#6b7280",
    marginBottom:"15px"
  },

  meta:{
    display:"flex",
    gap:"8px",
    fontSize:"13px",
    color:"#9ca3af"
  },

  loading:{
    textAlign:"center",
    padding:"80px",
    fontSize:"18px"
  }

};